import { useState } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
  GetTrackShipmentAPI,
  GetTrackYourtruckAPI,
} from '../api/oms/track-package';
import { GetTrackPackageRequest } from '../models/order-details';
import {
  ITrackYourTruckRequest,
  ITrackYourTruckResponse,
  IShipmentTrackingDetail,
} from '../models/order-details/track-shipment';

export const GetTrackShipmentData = (requestData: GetTrackPackageRequest) => {
  const [trackShipmentData, setTrackShipmentData] =
    useState<IShipmentTrackingDetail | null>(null);
  const [trackShipmentError, setTrackShipmentError] =
    useState<AxiosError | null>(null);
  const [trackShipmentLoaded, setTrackShipmentLoaded] = useState(false);

  const handleTrackShipmentAPIButtonClick = async () => {
    try {
      const response = await GetTrackShipmentAPI(requestData);
      setTrackShipmentData(response.data?.shipmentTrackingDetail);
      setTrackShipmentLoaded(true);
    } catch (error) {
      setTrackShipmentError(error as AxiosError);
      setTrackShipmentLoaded(true);
    }
  };

  return {
    trackShipmentData,
    trackShipmentError,
    trackShipmentLoaded,
    handleTrackShipmentAPIButtonClick,
  };
};

// we will be using order-service api for this

export const GetTrackYourTruckData = (requestData: ITrackYourTruckRequest) => {
  const [trackYourTruckData, setTrackYourTruckData] =
    useState<ITrackYourTruckResponse | null>(null);
  const [trackYourTruckError, setTrackYourTruckError] =
    useState<AxiosError | null>(null);
  const [trackYourTruckLoaded, setTrackYourTruckLoaded] = useState(false);

  const handleTrackYourTruckAPICall = async () => {
    return GetTrackYourtruckAPI(requestData)
      .then((response: AxiosResponse<ITrackYourTruckResponse>) => {
        setTrackYourTruckData(response.data);
      })
      .catch((error: AxiosError) => {
        setTrackYourTruckError(error);
      })
      .finally(() => setTrackYourTruckLoaded(true));
  };
  return {
    trackYourTruckData: trackYourTruckData?.trackYourTruckResponse,
    trackYourTruckError,
    trackYourTruckLoaded,
    handleTrackYourTruckAPICall,
  };
};
